import { BackgroundFloatingBoxes } from "components/BackgroundFloatingBoxes"
import CardsFooter from "components/Footers/CardsFooter";
import DemoNavbar from "components/Navbars/DemoNavbar"
import Pricing from "components/Pricing";
import { Helmet } from "react-helmet";
// reactstrap components
import {
    Container,
    Row,
    Col
} from "reactstrap";

const FAQS = [
    {
        q: "Is there a free trial?",
        a: "Yes. Every plan includes a 14-day free trial so you can see the lift in your own store before paying anything."
    },
    {
        q: "Do I need a credit card for the trial?",
        a: "Yes, a credit card is required to start your trial — but you won't be charged until the 14-day trial ends. Cancel before then and you pay nothing."
    },
    {
        q: "How do I cancel?",
        a: "Cancel anytime. Self-serve plans can be cancelled from the Subscriptions page in your dashboard; Shopify subscriptions end when you uninstall the app."
    },
    {
        q: "How long does integration take?",
        a: "Our Javascript SDK and REST API get most stores up and running in less than 10 minutes."
    },
    {
        q: "What do I need to get started?",
        a: "Add your shipping carriers, add at least one warehouse with an accurate address, and generate an API key in your dashboard. That's it."
    },
    {
        q: "What if none of the plans fit?",
        a: "Large stores can contact us for an Enterprise quote — tell us about your order volume and we'll tailor pricing to your needs."
    }
];

const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQS.map(({ q, a }) => ({
        "@type": "Question",
        "name": q,
        "acceptedAnswer": { "@type": "Answer", "text": a }
    }))
};

export const PricingPage = () => {
    return (<>
        <Helmet>
            <title>Pricing - Convert Logistics</title>
            <meta name="description" content="Simple plans for any size store. Every plan includes a 14-day free trial — no charge until your trial ends." />
            <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        </Helmet>
        <DemoNavbar />
        <main>
            <div className="position-relative">
                {/* shape Hero */}
                <section className="section section-lg section-shaped pb-250">
                    <BackgroundFloatingBoxes color="default" />
                    <Container className="py-lg-md mt-5">
                        <h1 className="text-white">Our Pricing</h1>
                        <h3 className="text-white">All plans include a 14-day free trial!</h3>
                        <h5 className="text-white">We offer affordable plans for businesses of all sizes</h5>
                        <p className="text-white"><small>14-day free trial &middot; No charge until your trial ends &middot; Cancel anytime</small></p>
                        <Pricing />
                    </Container>
                    {/* SVG separator */}
                    <div className="separator separator-bottom separator-skew">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                            />
                        </svg>
                    </div>
                </section>
                {/* 1st Hero Variation */}
            </div>
            <section className="section section-sm">
                <Container>
                    <h2 className="mb-4">Frequently asked questions</h2>
                    {FAQS.map(({ q, a }, i) => (
                        <div key={i} className="mb-4">
                            <h5>{q}</h5>
                            <p className="text-muted">{a}</p>
                        </div>
                    ))}
                </Container>
            </section>

        </main>
        <br />
        <br />
        <br />
        <br />
        <CardsFooter />
    </>
    )
}